<template>
  <div
    class="col"
    data-test-id="address-input"
  >
    <q-select
      :model-value="formattedAddress"
      :options="places"
      :option-label="(option) => option.properties ? option.properties.formatted : option"
      :use-input="$_.isEmpty(formattedAddress)"
      clearable
      color="responsive"
      :label="$t('form.labels.fullAddress')"
      input-debounce="800"
      hide-dropdown-icon
      :loading="loadingPlaces"
      @clear="clear(false)"
      @filter="filterPlaces"
      @update:model-value="setAddress"
    />
    <q-expansion-item
      class="bordered"
      :label="$t('form.labels.address')"
      expand-icon="fal fa-chevron-down"
      expand-separator
      :default-opened="addressIsRequired"
    >
      <address-form
        :user="user"
        :address-is-required="addressIsRequired"
        @editing="hasManualEdits = true"
      />
    </q-expansion-item>
  </div>
</template>

<script>
import User from 'src/models/user/User'
import AddressForm from 'src/modules/auth/components/AddressForm'

export default {
  name: 'AddressInput',
  components: {
    AddressForm
  },
  props: {
    user: {
      type: User,
      required: true
    }
  },
  data () {
    return {
      editing: !this.user.fullAddress?.formatted_address,
      hasManualEdits: false,
      addressSearchString: '',
      places: []
    }
  },
  configuration: ['currentCircuit', 'currentSite'],
  computed: {
    formattedAddress () {
      return this.user.fullAddress?.formatted_address
    },
    hasNoAddress () {
      return !this.user.fullAddress?.formatted_address
    },
    hasFullAddress () {
      const addressComponentTypes = _(this.user.fullAddress.address_components).map('types').flatten().uniq().value()
      return _.every(['street_number', 'route'], type => _.includes(addressComponentTypes, type))
    },
    addressIsRequired () {
      if (!this.currentCircuit.registrationOptions.require_address) {
        return false
      } else {
        // IGNORE ADDRESS REQUIREMENT IN ADMIN AND POS
        return !this.$register && !this.$admin
      }
    }
  },
  watch: {
    editing () {
      if (this.editing) {
        this.clear(false)
      }
    },
    async addressSearchString () {
      if (!_.isEmpty(this.addressSearchString)) {
        this.places = await this.$geoapify.getAutocompleteOptions(this.addressSearchString, [this.currentCircuit.iso31661])
      } else {
        this.places = []
      }
    },
    hasManualEdits () {
      if (this.hasManualEdits) {
        this.clear(true)
      }
    }
  },
  methods: {
    async filterPlaces (value, update) {
      update(() => {
        this.addressSearchString = value
      })
    },
    // eslint-disable-next-line camelcase
    async setAddress (place) {
      console.log('place', place)
      const { properties } = place

      // eslint-disable-next-line camelcase
      const { address_line1, address_line2, city, state, postcode, formatted } = properties

      this.hasManualEdits = false

      this.user.fullAddress = {
        formatted_address: formatted,
        address_components: [],
        // eslint-disable-next-line camelcase
        address_line_1: address_line1,
        // eslint-disable-next-line camelcase
        address_line_2: address_line2,
        city,
        state,
        // eslint-disable-next-line camelcase
        post_code: postcode
      }
    },
    clear (manualEdits = false) {
      if (manualEdits) {
        this.user.fullAddress.formatted_address = null
        this.$refs.addressAutocomplete.clear()
      } else {
        this.user.fullAddress = {
          formatted_address: null,
          address_components: [],
          address_line_1: null,
          address_line_2: null,
          city: null,
          state: null,
          post_code: null
        }
        this.$refs.addressAutocomplete.clear()
        this.$refs.addressAutocomplete.focus()
      }
    }
  }
}
</script>

<style>
.address-display {
  padding-top: 24px;
  padding-bottom: 8px;
}

.address-autocomplete {
  padding-top: 24px;
  padding-bottom: 8px;
  border: none;
  width: 100%
}

.hidden {
  display: none;
}

.address-autocomplete:focus {
  outline: none;
}

.autocomplete-wrapper .q-field__native{
    display: none;
}

.pac-container, .pac-item {
    /* GOOGLE MAPS AUTOCOMPLETE DROPDOWN IN ADMIN DOESN'T DISPLAY CORRECTLY WITHOUT THIS */
    z-index: 10000 !important;
 }
</style>
